<template>
  <canvas
    id="can"
    :width="canvasW"
    :height="canvasH"
    @mousedown.stop="mouseDownAction($event)"
    @mousemove.stop="mouseMoveAction($event)"
    @mouseup.stop="mouseUpAction($event)"
    @touchstart.stop="touchS($event)"
    @touchmove.stop="touchM($event)"
    @touchend.stop="touchE($event)"
  ></canvas>
</template>

<style>
canvas {
  border-radius: 0 0 1rem;
  user-select: none;
}
</style>

<script>
export default {
  props: {
    value: {}
  },
  data() {
    return {
      bot: null, // Canvas div
      X: null,
      Y: null,
      X1: null,
      Y1: null, // Coordinates
      flag: 0,
      time: null, // Timer ID
      color: 0, // Remember selected color
      lineW: 2, // Brush thickness
      canvas: null, // Create canvas
      context: null, // Get context
      isMouseDown: false, // Record whether mouse is pressed
      isClearCanvas: false
    };
  },

  mounted() {
    this.isClearCanvas = this.value;
    this.canvas = document.getElementById("can");
    // Get context
    this.context = this.canvas.getContext("2d");
  },
  destroyed() {},

  computed: {
    canvasW() {
      return this.$store.state.fontSize * 27.1;
    },
    canvasH() {
      return this.$store.state.fontSize * 12.2;
    }
  },

  methods: {
    touchS(e) {
      e.preventDefault();

      this.isMouseDown = true;

      var touch = e.changedTouches[0];
      this.X = touch.pageX - touch.target.offsetLeft;
      this.Y = touch.pageY - touch.target.offsetTop;

      document.touchend = () => {
        this.touchE();
      };
    },
    touchM(e) {
      e.preventDefault();

      var touch = e.changedTouches[0];
      console.log(
        touch.pageX - touch.target.offsetLeft,
        touch.pageY - touch.target.offsetTop
      );

      if (this.isMouseDown) {
        this.X1 = touch.pageX - touch.target.offsetLeft;
        this.Y1 = touch.pageY - touch.target.offsetTop;
        this.drowline(this.X, this.Y, this.X1, this.Y1);
        this.flag++;
      }
    },
    touchE(e) {
      e.preventDefault();

      this.isMouseDown = false;
      this.flag = 0;
      this.save_pic();
    },
    /**
     * Mouse down
     */
    mouseDownAction(e) {
      this.isMouseDown = true;
      // Record mouse position when clicked
      this.X = e.offsetX;
      this.Y = e.offsetY;
      let _this = this;
      document.onmouseup = () => {
        this.mouseUpAction();
      };
    },

    /**
     * Mouse move
     */
    mouseMoveAction(e) {
      if (this.isMouseDown) {
        this.X1 = e.offsetX;
        this.Y1 = e.offsetY;
        this.drowline(this.X, this.Y, this.X1, this.Y1);
        this.flag++;
      }
    },

    /**
     * Mouse up
     */
    mouseUpAction(e) {
      this.isMouseDown = false;
      this.flag = 0;
      document.onmouseup = null;
      this.save_pic();
    },
    /**
     * Draw
     */
    drowline(num1, num2, num3, num4) {
      // Start new path
      if (this.flag) this.context.beginPath();
      // Move brush to initial position
      this.context.moveTo(num1, num2);
      this.context.lineWidth = 2;
      // this.context.strokeStyle="red";

      // Move brush to end position
      this.context.lineTo(num3, num4);
      // Start drawing
      this.context.stroke();

      if (this.flag != 0) {
        this.X = this.X1;
        this.Y = this.Y1;
      }
    },
    save_pic() {
      // Save drawing
      let str = this.canvas.toDataURL("image/png", 0.92);
      this.$emit("updateImgUrl", str);
      //console.log('更新路径')
    }
  },
  watch: {
    value(newVal, oldVal) {
      this.isClearCanvas = newVal;
    },
    isClearCanvas(val) {
      if (val) {
        console.log(val);
        this.context.beginPath();
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context.closePath();
        this.isClearCanvas = false;
        this.$emit("updateImgUrl", null);
      }
      this.$emit("input", val);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/units/painting.vue